import React from 'react';
import { Container } from 'react-bootstrap';

const Payment = () => {
    return (
       <Container>
           <h1>payment Comming soon</h1>
       </Container>
    );
};

export default Payment;